import * as stylex from "@stylexjs/stylex";
import { Button } from "@softmax/design-system";
import { styles } from "../onboarding.styles";
import { steps } from "../onboarding-steps";
import type { OnboardingProgress } from "../onboarding-progress";
import { doneResultFor } from "./onboarding-step-result";

export function CompletedStep({
  step,
  progress,
  agentLabel,
  onSwitchAccount,
}: Readonly<{
  step: (typeof steps)[number];
  progress: OnboardingProgress;
  agentLabel: string;
  onSwitchAccount(): void;
}>) {
  return (
    <p {...stylex.props(styles.copy, styles.result)}>
      {step.key === "signIn" && progress.viewerName ? (
        <>
          <span>Signed in as</span>
          {doneResultFor({ key: step.key, progress, agentLabel })}
          <Button
            variant="quiet"
            size="sm"
            data-switch-account
            onClick={onSwitchAccount}
          >
            Not you? Switch account
          </Button>
        </>
      ) : (
        <>
          <span data-done-title>{step.title}</span>
          {doneResultFor({ key: step.key, progress, agentLabel })}
        </>
      )}
    </p>
  );
}
